import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { Modal } from "antd";
import AddLanguageModalContent from './AddLanguageModalContent';
import AddLabelModalContent from './AddLabelModalContent';
import EditLabelModal from './EditLabelModal';
import ImportFileModalContent from './ImportFileModalContent';
import AddLanguageEquivalentModal from './AddLanguageEquivalent';
import EditLanguageEquivalentModal from './EditLanguageEquivalentModal';

const LanguagePageModals = forwardRef((props, ref) => {
    const [deleteModal, setDeleteModal] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [labelObject, setLabelObject] = useState({});

    useImperativeHandle(ref, () => ({
        toggleDeleteModal(modalType, labelData) {
            setLabelObject(labelData)
            setModalContent(modalType)
            setDeleteModal(!deleteModal)
        }

    }));

    const closeModal = () => {
        setDeleteModal(false)
    }

    return (
        <div>
            <Modal centered visible={deleteModal} destroyOnClose maskClosable={false} onCancel={() => setDeleteModal(false)} footer={null}>
                {
                    modalContent == "add_translation" ?
                        <AddLanguageEquivalentModal closeModal={closeModal} />
                        : modalContent == "Import file" ?
                            <ImportFileModalContent closeModal={closeModal} />
                            : modalContent == "Edit label" ?
                                <EditLabelModal labelData={labelObject} closeModal={closeModal} />
                                : modalContent == "edit_language_equivalent" ?
                                    <EditLanguageEquivalentModal labelData={labelObject} closeModal={closeModal} />
                                    : modalContent == "Add Label" ?
                                        <AddLabelModalContent closeModal={closeModal} />
                                        : <AddLanguageModalContent closeModal={closeModal} />
                }
            </Modal>
        </div>
    )
})
export default LanguagePageModals;